module.exports = __webpack_public_path__ + "static/media/376.06bb027c.png";